import { apiSlice } from './apiSlice'

/**
 * Quality Control › Nestle Sample (Sampling Export) datasheet.
 *
 * Mirrors FastAPI `NestleSampleOut` — Access `frmQualityQrySamplingExp` over
 * view `tlc_factory.view_factory_sampling3_exp2`. The view exposes generic
 * `col1..col25` aliases; each maps to an Access Label.Caption in the list view.
 */
export interface NestleSample {
  id: number
  col1: string | null
  col2: string | null
  col3: string | null
  col4: string | null
  col5: string | null
  col6: string | null
  col7: string | null
  col8: string | null
  col9: string | null
  col10: string | null
  col11: string | null
  col12: string | null
  col13: number | string | null
  col14: number | string | null
  col15: string | null
  col16: string | null
  col17: string | null
  col18: string | null
  col19: string | null
  col20: string | null
  col21: string | null
  col22: string | null
  col23: string | null
  col24: string | null
  col25: string | null
}

export interface NestleSampleListResponse {
  items: NestleSample[]
  total: number
  page: number
  pageSize: number
}

export interface NestleSampleListQuery {
  page: number
  pageSize: number
  startDate?: string
  endDate?: string
}

const qualityNestleSampleApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNestleSamples: builder.query<NestleSampleListResponse, NestleSampleListQuery>({
      query: ({ page, pageSize, startDate, endDate }) => ({
        url: '/quality-nestle-samples',
        params: {
          page,
          pageSize,
          ...(startDate ? { startDate } : {}),
          ...(endDate ? { endDate } : {}),
        },
      }),
      providesTags: ['QualityNestleSample'],
    }),
  }),
})

export const { useGetNestleSamplesQuery } = qualityNestleSampleApi
export default qualityNestleSampleApi
